import { render, staticRenderFns } from "./LeaveListApprover.vue?vue&type=template&id=476445fe"
import script from "./LeaveListApprover.vue?vue&type=script&lang=js"
export * from "./LeaveListApprover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports